module.exports = __webpack_public_path__ + "static/media/RP-44.3d937438.pdf";